import type { ReactElement } from 'react';
import { mergeSx } from 'components/ui/utilities/mergeSx';
import { DividerProps } from './Divider.props';
import { dividerLabeledAccentSx, StyledDivider } from './Divider.styles';

const dividerVisualVariantSx = {
  labeledAccent: dividerLabeledAccentSx,
} as const;

const Divider = ({ label, sx, visualVariant, ...props }: DividerProps): ReactElement => {
  const presetSx = visualVariant ? dividerVisualVariantSx[visualVariant] : undefined;
  const mergedSx = mergeSx(presetSx, sx);

  return (
    <StyledDivider sx={mergedSx} {...props}>
      {label}
    </StyledDivider>
  );
};

export default Divider;
